import React from "react";
// import whatsAppIcon from "../../assets/images/whats-app.svg";
import Button from "../../components/Button";
import CONTACT_DATA from "../../utils/ContactUs";
const Contactus = () => {
  // Smooth scroll function
  const handleSmoothScroll = (event) => {
    event.preventDefault(); // Prevent default anchor behavior
    const target = document.querySelector("#currencyForm"); // Get the target element
    if (target) {
      target.scrollIntoView({
        behavior: "smooth", // Enable smooth scrolling
        block: "start", // Align to the top of the target element
      });
    }
    // if (onClick) {
    //   onClick(event); // Call the provided onClick handler if it exists
    // }
  };
  return (
    <div className="mb-20 mt-[100px]">
      <h1 className="text-5xl font-bold px-6 md:px-20 my-10 leading-tight">
        Contact Us – We're Here to Help!
      </h1>
      <div className="flex flex-col-reverse md:flex-row  px-6 md:px-20 gap-16 ">
        <div className="flex flex-col gap-5 w-full md:w-[50%]">
          <h2 className="text-lg font-semibold md:text-xl md:font-bold text-[#888888] leading-tight">
            Have questions about money transfers? Reach out for:
          </h2>
          <div className="flex flex-col items-center gap-6">
            <div className="bg-[#eadaff] p-8 w-full text-center font-semibold md:text-left rounded-md flex flex-col gap-4 flex flex-col gap-4">
              <ul className="flex flex-col gap-3">
                {CONTACT_DATA.need_help_list.map((item, index) => {
                  return <li>{item}</li>;
                })}
              </ul>
            </div>
            <h2 className="text-lg font-semibold md:text-xl md:font-bold leading-tight">
              Note: We’re a comparison platform, not a transfer service. For
              transaction issues, contact your provider directly.
            </h2>
            {/* <div className="p-8 w-full text-center font-semibold md:text-left rounded-md flex flex-col gap-4">
              <p className="font-bold">{CONTACT_DATA.compare}</p>
              <ul className="list-disc list-inside flex flex-col gap-3">
                {
                  CONTACT_DATA.compare_list.map((item, index) => {
                    return <li>{item}</li>
                  })
                }
              </ul>
            </div>
            <div className="bg-[#eadaff] p-8 w-full text-center font-semibold md:text-left rounded-md flex flex-col gap-4">
              <p className="font-bold">{CONTACT_DATA.experience_heading}</p>
              <ul className="list-disc list-inside flex flex-col gap-3">
                {
                  CONTACT_DATA.experience_list.map((item, index) => {
                    return <li>{item}</li>
                  })
                }
              </ul>
            </div>
            <div className="p-8 w-full text-center font-semibold md:text-left rounded-md flex flex-col gap-4">
              <p className="font-bold">{CONTACT_DATA.growth_heading}</p>
              <ul className="list-disc list-inside flex flex-col gap-3">
                {
                  CONTACT_DATA.growth_list.map((item, index) => {
                    return <li>{item}</li>
                  })
                }
              </ul>
            </div>
            <div className="bg-[#eadaff] p-8 w-full text-center font-semibold md:text-left rounded-md flex flex-col gap-4">
              <p className="font-bold">{CONTACT_DATA.disclaimer_heading}</p>
              <ul className="list-disc list-inside flex flex-col gap-3">
                {
                  CONTACT_DATA.disclaimer_list.map((item, index) => {
                    return <li>{item}</li>
                  })
                }
              </ul>
            </div> */}
          </div>
        </div>
        {/* <div className="flex flex-col gap-8 shadow-lg px-5 md:px-12 py-5 md:w-[50%] w-full rounded-2xl h-fit">
          <div className="flex flex-col gap-2 ">
            <lable className="font-bold">Email ID * </lable>
            <input
              type="text"
              placeholder="example: rahulpant@gmail.com"
              className="border border-[#CCCCCC] rounded-lg p-2"
            />
          </div>
          <div className="flex flex-col gap-2">
            <lable className="font-bold">Company Name * </lable>
            <input
              type="text"
              placeholder="example: rahulpant@gmail.com"
              className="border border-[#CCCCCC] rounded-lg p-2"
            />
          </div>
          <div className="flex flex-col gap-2">
            <lable className="font-bold">What are you looking for? *</lable>
            <input
              type="text"
              placeholder="example: rahulpant@gmail.com"
              className="border border-[#CCCCCC] rounded-lg p-2"
            />
          </div>
          <div className="flex justify-end">
          <Button
          btnText="Submit"
          onClick={handleSmoothScroll}
          classes="bg-[#7B3BCC] w-[100px] mt-5 text-sm bg-[#1A94FF] text-white font-bold py-3 mb-2 sm:text-base md:w-[150px] md:mx-auto lg:w-[150px] lg:text-lg xl:text-[16px] lg:mt-8 transition-colors hover:bg-[#6a30b5] duration-300"
        />
          </div>
        </div> */}
        <div className="flex flex-col gap-8 shadow-lg px-5 md:px-12 py-5 md:w-[50%] w-full rounded-2xl h-fit m-auto">
          <div className="flex flex-col gap-2 text-[#888888] font-[600]">
            <h2>If you have any query, please feel free to contact us:</h2>
            <h2>
              Email:{" "}
              <a
                href="mailto:product@upgrowthmarketing.in"
                className="text-[#7B3BCC] underline"
              >
                product@upgrowthmarketing.in
              </a>
            </h2>
            <ul>
              <li>MoneyRateFinder</li>
              <li>C 133, Chattarpur Enclave</li>
              <li>Phase 2, New Delhi - 110074, India</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactus;
